import "./Line.scss"

function Line(){
    return(
        <>
            <div className="line">

            </div>
        </>
    )
}

export default Line;